/**
 * Individual-agent presence for dashboard widgets — responsive fill layout.
 */
import type { AgentStatusRow } from './AgentTile';
import AgentTile from './AgentTile';

interface AgentPresenceSingleProps {
  agent: AgentStatusRow;
  avatarUrl?: string;
  /** Catalog-resolved campaign names; omitted when widget hides campaigns */
  campaignDisplay?: string;
}

export default function AgentPresenceSingle({ agent, avatarUrl, campaignDisplay }: AgentPresenceSingleProps) {
  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        width: '100%',
        display: 'flex',
        alignItems: 'stretch',
        containerType: 'size',
        containerName: 'agent-single',
      }}
    >
      <AgentTile
        agent={agent}
        avatarUrl={avatarUrl}
        compact
        fill
        hideName
        hideTeam
        campaignDisplay={campaignDisplay}
      />
    </div>
  );
}
